module.exports = __webpack_public_path__ + "images/48f28d66cd12b4791a1f4d45c89a4c86.png";